<template>
  <div class="homework-content" :class="status === '0'? '' : 'comment'">
    <div class="content">
    <!-- 标题 -->
    <van-nav-bar
        title="作业"
        left-arrow
        @click-left="$router.back()"
    />
    <!-- 老师点评 -->
    <div class="teacher-comment-wraper" v-if="status === '1' || status === '2'">
      <div class="tearcher-comment-content">
        <div class="teacher-comment " :class="status==='1'?'pass':status==='2'?'inpass':''" >
          <div class="left">
            {{teacherComment? teacherComment : '暂无评语'}}
          </div>
          <div class="right">
            <img src="../../../assets/images/course/zuoye/pass-img.png"/>
          </div>
          <div class="teach">老师点评</div>
        </div>
      </div>
    </div>
    <!-- 作业题目 -->
    <div class="hw-title">
      <p class="title">作业题目</p>
      <p class="hm-content">
        {{homewrokObj.content}}
      </p>
      <ul class="fujian" v-show=" homewrokObj.homeworkResource &&  homewrokObj.homeworkResource.length">
        <li class="item"
          v-for="(item, index) in  homewrokObj.homeworkResource"
          :key="index"
        >
          <img class="logo" :src="item.src"/>
          <span class="hw-name">
            <span class="prefix ellipsis" :class="item.fileType === 6?'is-zip':''">{{item.prefix}}</span>
            <span class="suffix">{{item.suffix}}</span>
          </span>
          <span class="text" v-if="item.fujian || item.fileType === 6">压缩包请电脑端查看</span>
          <span class="more" @click="showAccessoryPop(item)" v-else></span>
        </li>
      </ul>
    </div>
    <!-- 学员作答 -->
    <div class="stu-answer">
       <p class="title">学员作答</p>
       <!-- 图片 -->
       <ul class="upload-list" >
         <li class="upload-item" :class="item.url?'': 'show-border'" v-for="(item, index) in picList" :key="index">
            <img :src="item.url" @click="preview(item, index, 1)"/>
            <div class="close-btn"  v-show="submitTag != 1" @click.prevent="delItem(index,1)">
                <svg-icon icon-class="homework-del-button" class-name="homework-del-button"></svg-icon>
            </div>
            <div class="progress" v-show="item.progress && item.progress<100">上传中 {{item.progress}}%</div>
         </li>
        <van-uploader 
          :before-read="beforeUploadImg"
          :after-read="handleClickUpload" 
          accept="image/*" 
          max-size="5*1024*1024"
          v-if="submitTag != 1"
          >
            <div class="upload-item uploader show-border">
                <svg-icon icon-class="homework-upload-img" class-name="homework-upload-icon"></svg-icon>
              <span>上传图片</span>
            </div>
         </van-uploader>
       </ul>
       <!-- 视频 -->
      <ul class="upload-list" >
        <li class="upload-item" :class="item.id?'': 'show-border'" v-for="(item, index) in videoList" :key="index">
          <!-- <video 
            v-if="!item.id"
            x-webkit-airplay webkit-playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true" x5-video-orientation="portraint" playsinline="true"
            style="width:100%;height:100%;object-fit: fill"
            :poster="item.url?`${item.url}?x-oss-process=video/snapshot,t_1000,f_png,w_154,h_154,m_fast`:''"
            >
              <source :src="item.url"  type="video/*">
            </video> -->
          <div class="zhuanma" v-if="!item.id && item.progress == 100" @click="preview(item, index, 2)">
            <span>转码中</span>
            <span>请稍后</span>
          </div>
          <img :src="item.coverUrl" @click="preview(item, index, 2)" v-else/>
          <div class="close-btn" v-show="submitTag != 1" @click.prevent="delItem(index,2)">
              <svg-icon icon-class="homework-del-button" class-name="homework-del-button"></svg-icon>
          </div>
          <div class="progress" v-show="item.progress && item.progress<100">上传中 {{item.progress}}%</div>
          <div class="video-logo" @click="preview(item, index, 2)" v-show="item.id">
              <svg-icon icon-class="homework-video-playButton" class-name="homework-video-playButton"></svg-icon>
          </div>
          <!-- <div></div> -->
        </li>
         <van-uploader 
          :after-read="afterReadVideo" 
          v-if="submitTag != 1"
          max-size="500*1024*1024"
          accept="video/*, image/*,"
          :before-read="beforeReadVideo"
        >
          <div class="upload-item uploader show-border">
            <svg-icon icon-class="homework-upload-video" class-name="homework-upload-icon"></svg-icon>
            <span>上传视频</span>
          </div>
        </van-uploader>
      </ul>
      <p class="message" v-if="submitTag === 0 || (submitTag === 1 && stuMessage)" >
        <van-field 
          v-model="stuMessage" 
          style="padding:0px;background-color: transparent"
          type="textarea"
          maxlength="500"
          placeholder="作业以附件形式提交，留言仅做备注使用"
          show-word-limit
          ref="file"
          :disabled="(status == '1' )|| (status === '2') || (submitTag === 1) "
        />
      </p>
    </div>
    </div>
    <van-popup class="pop-zuoye" v-model="accessoryPop" position="bottom">
      <ul class="pop-wraper">
        <li class="name-resource">{{accessoryDetail.name}}</li>
        <li class="preview-donload" @click="assesoryPreview">预览</li>
        <li class="preview-donload" @click="assesoryDownload" v-show="accessoryDetail.fileType === 4">下载</li>

      </ul>
      <div class="cancle" @click="accessoryPop = false">取消</div>
    </van-popup>
    <!-- 图片预览 -->
    <van-dialog
      style="border-radius:0"
      theme="default"
      v-model="ispreviewImg"
      :show-cancel-button="true"
      :show-confirm-button="false"
      closeOnClickOverlay
    >
      <img width="320px" :src="previewImg.url"/>
      <!-- <div class="hw-local-preview" @click.prevent="ispreviewImg = false"></div> -->
    </van-dialog>
    <!-- 视频 -->
    <van-dialog
      style="border-radius:0"
      theme="default"
      v-model="ispreviewVideo"
      :show-cancel-button="true"
      :show-confirm-button="false"
      closeOnClickOverlay
      @close="close"
    >
      <video
        ref="localVideo"
        controls="controls"
        preload="auto"
        style="width: 100%; height: 100%; object-fit: fill"
        :src="previewVideo.url"
        :poster="`${previewVideo.url}?x-oss-process=video/snapshot,t_1000,m_fast`"
        v-if="!previewVideo.id"
      >
      </video>
      <div class="player-wraper" v-else>
        <videoplayer 
          ref="videoraasplayer" 
          class="videoPlayerBox" 
         >
        </videoplayer>
      </div>
       <!-- <div class="hw-local-preview" @click="ispreviewVideo = false"></div> -->
    </van-dialog>
    <!-- 提交作业二次确认 -->
    <van-dialog v-model="showTip" :showConfirmButton="false">
      <div class="tooltip">
        <img class="bg-img" src="../../../assets/images/course/zuoye/tooltip.png"/>
        <span class="warn">提示</span>
        <!-- <span class="tip-text"></span> -->
        <span class="tip-text">是否提交当前作业内容?</span>

        <div class="buttons">
          <div class="cancle-submit button" @click="showTip  = false">取消</div>
          <div class="confirm button" @click="confirm">确定</div>
        </div>
      </div>
    </van-dialog>
    <div class="sub-btn" @click="submit" v-show="status != '1' && status !='2'" >{{submitText}}</div>
  </div>
</template>
<script>
import audio from '../../../assets/images/course/zuoye/audio.png'
import doc from '../../../assets/images/course/zuoye/doc.png'
import img from '../../../assets/images/course/zuoye/img.png'
import video from '../../../assets/images/course/zuoye/video.png'
import zip from '../../../assets/images/course/zuoye/zip.png'
const imgRgx = /\.(jpg|jpeg|png|JPG|PNG|bmp|gif|GIF)$/
const videoRgx = /\.(mp4|avi|wmv|flv|rmvb|3gp|m4v|mkv|MOV|mov)$/
const OSS = require("ali-oss");
export default {
  name: 'homeworkDetail',
  data() {
    return {
      accessoryPop: false, // 附件pop
      accessoryDetail: {},
      ispreviewVideo: false,
      previewVideo: {},
      ispreviewImg: false,
      previewImg: {},
      picList: [],
      videoList: [],
      docList: [],
      stuMessage: '',
      homewrokObj: {},
      teacherComment: '',
      status: null,
      subclick: false,
      showTip: false,
      submitTag: -1,
      submitText: '提交作业',
      showUploader: false,
      goPreview: false
    }
  },
  watch: {
    ispreviewVideo(val) {
      if(!val) {
        this.$refs.localVideo.pause()
        let Vidpreview=document.querySelector('.web-office-default-container')
        document.body.removeChild(Vidpreview)
        // window.removeEventListener("popstate", this.pdfTiming, false); //false阻止默认事件
      }
    },
  },
  created() {
    this.courseId = this.$route.query.courseId
    // this.status = this.$route.query.status+''
    this.homeworkId =  this.$route.query.homeworkId
    this.taskId = this.$route.query.taskId
    // if(this.status === '3' || this.status === '2') {
    //   document.documentElement
    // }
    // zzzz
    
  },
  mounted() {
    this.findHomework()
  },
  methods: {
    close() {
      this.$refs.videoraasplayer.dispose()
    },
    // 查询作业信息
    // 查看作业/查看点评
    async findHomework() {
      const params = {
        courseId: this.courseId,
        homeworkId: this.homeworkId,
        taskId: this.taskId
      }
      let result = await this.$api.zuoye.findHomework(params)
      if(result.success) {
        this._handlechakan(result.data)
      }
    },
    async confirm() {
      if(this.subclick) {
        this.$toast('作业提交中，请勿重复提交')
        return
      }
      const params = this._handleSubmitParams()
      if(!params.resourceList.allTypeFileInfoDtoList.length) {
        this.$toast('请上传图片或视频作业')
        this.showTip = false
        return 
      }
      this.subclick = true
      
      let result = await this.$api.zuoye.answerHomework(params)
      if(result.success) {
        if(this.goPreview) {
          return
        }
        this.$toast({
          message: '提交成功',
          position: 'middle'
        })
        this.$router.back()
      }
      this.subclick = false
      this.showTip = false
    },
    // 提交作业
    submit() {
      if(this.submitTag === 1) { // 更新作业
        this.submitText = '提交作业'
        this.showUploader = true
        this.submitTag = 0
        return
      }
      this.showTip = true
    },
    // 提交作业时对数据进行处理
    _handleSubmitParams() {
      const params = {
        courseId: this.courseId,
        homeworkId: this.homeworkId,
        taskId: this.taskId,
        message: this.stuMessage
      }
      let fileArr = this.picList.map((item) => {
        const params = {}
        if(item.id) {
          params.id = item.id
          params.fileType = item.fileType
          params.name = item.name
          params.url = item.url
          params.bucketName = ''
          params.videoId = ''

        } else {
            params.fileType = item.fileType
            params.bucketName = item.bucketName
            params.name = item.name
            params.size = item.size
            params.url = item.url
            params.videoId = ''
        }
        return params
      })
      let videoArr = this.videoList.map((item) => {
        const params = {}
        if(item.id) {
          params.id = item.id
          params.fileType = item.fileType
          params.name = item.name
          params.url = item.url
          params.bucketName = ''

        } else {
            params.fileType = 1
            params.videoId = item.videoId
            params.name = item.fileName
            params.size = item.size
            params.url = item.url
            params.bucketName = ''
        }
        return params
      })
      // 如果pc端上传了文档
      let docList = this.docList.map((item) => {
        const params = {}
        if(item.id) {
          params.id = item.id
          params.fileType = item.fileType
          params.name = item.name
          params.url = item.url
          params.bucketName = ''

        }
        return params
      })
      const allTypeFileInfoDtoList = [...fileArr, ...videoArr, ...docList]
      params.resourceList = {
        allTypeFileInfoDtoList,
        "saasType": 0,
        "unitId": 342
      }
      return params
    },
    // 查看作业时对数据进行处理 包含图片信息 视频信息 作业信息等
    _handlechakan(obj) {
      this.status = obj.status + ''
      this.submitTag = obj.submitTag
      if(this.submitTag === 1) {
        this.submitText = '更新作业'

      }
      this.answerId = obj.answerId
      let homeworkObj = {}
      homeworkObj.content = obj.content
      const reg = /\.(zip)$/
      homeworkObj.homeworkResource = obj.homeworkResource && obj.homeworkResource.map((item) => {
        if(item.name.length) {
          const nameArr =  item.name.split('.')
          item.suffix = '.'+nameArr[nameArr.length-1] // 后缀
          item.prefix = item.name.slice(0, -item.suffix.length)
        } else {
          item.suffix = ''
          item.prefix = ''
        }
        let type = item.fileType // 图片4、视频1、音频2、文档3、压缩包6
          switch (type) {
            case 1: // 
              item.src = video
              break;
            case 2:
              item.src = audio
              break;
            case 3:
              if(reg.test(item.name)) { // 
                item.src = zip
                item.fujian = true
              } else {
                item.src = doc
              }
              break;
            case 4:
              item.src = img
              break;
            case 6:
              item.src = zip
              break;
            default:
              break;
          }
          return item
      })
        
      this.homewrokObj = {...homeworkObj}
        // if(this.status  != '0') { // 非未提交 处理学生作答资源问题
      obj.answerResource && obj.answerResource.forEach((item) => {
        let type = item.fileType // 图片4、视频1、音频2、文档3、压缩包6
        switch (type) {
          case 4:
            this.picList.push(item)
            break;
          case 1:
            this.videoList.push(item)
            break;
          
          default:
            this.docList.push(item)
            break;
        }
      })
      // if(this.status === '2' || this.status === '3') {
      this.teacherComment = obj.comment?obj.comment : ''
      // }
      this.stuMessage = obj.message?obj.message:''
        // } 
    },
    // 图片、视频删除
    delItem(index,type) {
      console.log('000000', index, type)
      if(type === 1) { // image
        if(this.picList[index].progress && this.picList[index].progress!==100 ) {
          this.$refs.picFile.abortUploadImg(this.picList[index], index)
        }
        this.picList.splice(index, 1)
      } else { // video
        const item = {...this.videoList[index]}
        this.videoList.splice(index, 1)
        if(this.videoList[index].progress && this.videoList[index].progress !=100 ) {
          this.$refs.file.abortUpload(item) 
        } 
      }
    },
    // 预览
    preview(item, index, type) {
      // this.goPreview = true
      if(type === 1) { // 图片
        this.previewImg = {...item}
        this.ispreviewImg = true
        // 
        // this.confirm()
        // this.$router.push({
        //   name: 'hwResourcePreview',
        //   params: {
        //     id: item.id,
        //     url: item.url,
        //     fileType: item.fileType,
        //     isLocal: false,
        //   }
        // })
        return 
        
      } else { // 视频
        if(item.transcodingStatus != null && item.id) {
          //
          if(item.transcodingStatus === 1) {
            this.$toast({
              message: '转码中，请稍后查看',
              position: 'middle'
            })
            return
          } else if(item.transcodingStatus === 0) { // 未转码
            this.$toast({
              message: '未转码，请稍后查看',
              position: 'middle'
            })
            return
          } else if(item.transcodingStatus === 3) {
            this.$toast({
              message: '转码失败',
              position: 'middle'
            })
            return
          } else if(item.transcodingStatus === 2) {
            let params = {}
            this.$api.resource.previewMedias(item.id).then((res) => {
                if (res.success && res.data) {
                   this.ispreviewVideo = true
                    this.previewVideo = item
                    params = {
                        format: 'm3u8',
                        mediaType: 'video',
                    }
                    // 视频，安全相关的
                    this.curVideoUrl = res.data
                    this.$nextTick(() => {
                        this.$refs.videoraasplayer.initPlayer(this.curVideoUrl, params)
                    })
                   
                }
            })
            
            // 
            // this.confirm()

            // this.$router.push({
            //   name: 'hwResourcePreview',
            //   params: {
            //     id: item.id,
            //     url: item.url,
            //     fileType: 1,
            //     isLocal: false,
            //   }
            // })
          }

        } else {//
          if(item.progress && item.progress !== 100 ) {
            this.$toast({
              message: '上传中，请稍后查看',
              position: 'middle'
            })
            return
          } else {
            this.$toast('视频上传成功，转码中，请稍后查看')
            return 
          }
          

        }
        
        // this.confirm()
        // this.$router.push({
        //     name: 'hwResourcePreview',
        //     params: {
        //       id: item.id,
        //       url: item.url,
        //       fileType: 1,
        //       coverUrl: `${item.url}?x-oss-process=video/snapshot,t_1000,m_fast`,
        //       isLocal: true,
        //     }
        //   })
        
        // this.ispreviewVideo = true
        // this.previewVideo = item
      }
    },
    // 作业附件预览pop
    showAccessoryPop(item) {
      if(item) {
        this.accessoryDetail = {...item}
      }
      this.accessoryPop = true

    },
    // 作业附件预览
    async assesoryPreview() {
        if(this.accessoryDetail.transcodingStatus === 0) {
          this.$toast('未转码，请稍后查看')
        } else if(this.accessoryDetail.transcodingStatus === 1) {
          this.$toast('转码中，请稍后查看')
        } else if(this.accessoryDetail.transcodingStatus === 2) { // suceess
          if(this.accessoryDetail.fileType === 3) { // 文档
              // await this.getDocumentAccessToken(el)
              // await this.getSourseDetail(el);
         
          } else if(this.accessoryDetail.fileType === 4){ // 图片
              // await  this.getImageOrDocUrl(el)

          }
          this.previewVideo = {...this.accessoryDetail}
          this.ispreviewVideo = true
          // const curRow = JSON.stringify(this.accessoryDetail)
          this.$router.push({
            name: 'hwResourcePreview',
            params: {
              id: this.accessoryDetail.id,
              url: this.accessoryDetail.url,
              fileType: this.accessoryDetail.fileType
            }
          })
        } else if(this.accessoryDetail.transcodingStatus === 3) {
          this.$toast('转码失败')
        }
        this.accessoryPop = false
      //
      
    },
    // 作业附件下载
    assesoryDownload() {
      let row  ={...this.accessoryDetail}
      if(row.fileType === 4) {
        // 
        this.$toast('预览图片后长按保存')
        this.accessoryPop = false
        
      }

      // this.$api.resource.downFile(row.id).then(res => {
      //     if (res.data) {
      //     let fileUrl = res.data.fileUrl;
      //     // console.log("fileUrl", fileUrl);
      //     let index = res.data.fileName.split(".").length;
      //     let fileName = res.data.fileName.split(".")[index - 1];
      //     if (row.fileType === 4 || (row.fileType === 3 && fileName == "pdf")) {
      //         var xhr = new XMLHttpRequest();
      //         xhr.open("GET", fileUrl, true);
      //         xhr.responseType = "blob";
      //         xhr.onload = function(e) {
      //         // console.debug('e',e)
      //         if (e.target.readyState === 4 && e.target.status === 200) {
      //             let blob = this.response;
      //             // console.debug("blob", blob);
      //             // 转换一个blob链接
      //             let u = window.URL.createObjectURL(blob);
      //             // console.debug(u);
      //             let a = document.createElement("a");
      //             a.download = res.data.fileName;
      //             a.href = u;
      //             a.style.display = "none";
      //             document.body.appendChild(a);
      //             a.click();
      //             a.remove();
      //             window.URL.revokeObjectURL(u);
      //         }
      //         };
      //         xhr.send();
      //     } else {
      //         let a = document.createElement("a");
      //         a.download = res.data.fileName;
      //         console.log("a", a);
      //         a.href = fileUrl;
      //         a.style.display = "none";
      //         document.body.appendChild(a);
      //         a.click();
      //         a.remove();
      //     }
      //     // xhr.onprogress()
      //     }
      // });
    },
    handlebefread(file) {
      // if(!imgRgx.test(e.type.split('/')[1])) {
      //   // 
      //   this.$toast({
      //     message: '图片格式有误',
      //     position: 'middle'
      //   })
      // }
      // this.afterRead(file).then(res => {
      //   let params = {};
      //   params.url = res.default[0];
      //   params.name = res.name;
      //   console.log(params, '====')
      //   this.fileList.push(params);
      // });
    },
    beforeUploadImg() {
      if(this.picList.length >= 10) {
        this.$toast('最多上传10张图片')
        return false
      } else {
        return true
      }
    },
    // 上传图片
    async afterRead(fileList) {
      // this.videourl = file.content
      if(!Array.isArray(fileList)) {
        fileList = [fileList]
      }
      // const file = fileList;
      for(let i=0;i<fileList.length;i++) {
        const datas = await this.$api.zuoye.getAliyunConf();
        const ossClient = this.initOSSClient(datas);
        const fileType = "image";
        const uploadUrl = `${
          datas.data.filePathPrefix
        }${fileType}/${this.creatFileUrl(fileList[i].file.name)}`;
         
        // return new Promise((resolve, reject) => {
          ossClient
            .multipartUpload(uploadUrl, fileList[i].file,  {
						progress: (percentage, checkpoint) => this.handleProgess(percentage, fileList[i]),
					})
            .then(data => {
              if (data && data.res && data.res.status === 200) {
                const arr = data.res.requestUrls.map(element => {
                  let cbUrl = "";
                  if (element.indexOf("?uploadId") > -1) {
                    cbUrl = element.split("?")[0];
                  } else {
                    cbUrl = element;
                  }
                  return cbUrl;
                });
                // resolve({
                //   default: arr,
                //   name: data.name
                // });
                
              } else {
                // reject(data);
              }
            })
            // .catch(e => {
            //   reject(e);
            // });
        // });
      }

    },
    // 视频上传之前
    beforeReadVideo(file) {
      if(this.videoList.length >=10) {
        this.$toast('最多上传10个视频')

        return false
      } else {
        if(videoRgx.test(file.name)) {
          // 
          return true

        } else {
          this.$toast('视频格式有误')
          return false
        }
      }
    },
    // 上传视频
    afterReadVideo(videoList) {
      if(!Array.isArray(videoList)) {
        videoList = [videoList]
      }
      const len = this.videoList.length
      this.uploader = this.createUploader();
      Array.prototype.slice
        .call(videoList, 0, videoList.length)
        .forEach((v) => {
            let file = v.file
            this.uploader.addFile(
                file,
                null,
                null,
                null,
                `{"Vod":{}}`,
            );
      });
      this.checkFile(videoList).then(() => {
          // console.log(this.videoList, '=====ccccc222')

          this.videoList = [...this.videoList, ...this.parseData(this.uploader.listFiles())] ;
          console.log(this.videoList, '=====ccccc')
          this.uploader.startUpload();
          this.loading = true;
        }
      );
    },
    // 上传图片
    async handleClickUpload(files) {
				this.datas = await this.$api.zuoye.getAliyunConf();
				await this.initOSSClient(this.datas)
        if(!Array.isArray(files)) {
          files = [files]
        }
				let filesList = files;

				this.counts = filesList.length
				if (this.counts>100) {
					// this.tooltio.error('最多可上传100个文件');
				} else {
					this.fileList = []
          let len = this.picList.length
					for (let i = 0; i < this.counts; i++) {
						const fileInfo = {
							file: filesList[i].file,
							name: filesList[i].file.name,
							index: len+i,
							size: filesList[i].file.size,
              progress: 0,
						}
						localStorage.removeItem('ossCheckpoints-' + fileInfo.index)

						this.picList.push(fileInfo)
					}
          // const index = this.picList.findIndex(item => file)
					this.uploadFileList(len)
				}
    },
    uploadFileList(index) {
      //检查要上传的文件是否存在
      const file = this.picList[index]
      if (!file) return
      this.$set(file, 'path', this.creatFileUrl(file.name))
      this.handleUpload(file).then(res=>{
        // 判断是否为中止上传，isCancel取消正在上传
        if (!res.isCancel) {
          if (res.index <= this.counts) {
            this.uploadFileList(res.index+1)
          } else {
            console.log('upload list finished')
          }
        } else {
          localStorage.removeItem('ossCheckpoints-' + index)
          const deleteObj = Object.assign({isDelete: true}, this.picList[index])
          this.$emit('fileloadingdata', deleteObj)
          this.picList.splice(index, 1)
          if (this.picList.length> 0) {
            this.picList.forEach((it, i)=>{
              it.index = i
            })
            this.uploadFileList(index)
          } else {
            const fileRef = this.$refs.file
            fileRef.value = '';
          }
        }
      }).catch(e =>{
        // this.$message.error('上传出错了，请刷新页面重试')
        console.log(e)
      })
    },
    handleUpload(obj){
      const fileType = 'image'
      const uploadUrl = `${this.datas.data.filePathPrefix}${fileType}/${obj.path}`;
      const localCpt = localStorage.getItem('ossCheckpoints-' + obj.index);
      const checkpoint = JSON.parse(localCpt)
      let beforeNames = ''
      let afterNames = ''
      console.log('item',obj.name)
      // 拿到出去后缀的名字
      var counts =  obj.name.split('.').length
      obj.name.split('.').forEach((ite,ind) => {
          if(ind <= counts - 2){
            if(ind == counts - 2){
              beforeNames += ite
            }else{
              beforeNames += ite + '.'
            }
          }
      })
      afterNames = obj.name.split('.')[counts-1]
      return new Promise((resolve, reject)=>{
        this.ossClient.multipartUpload(uploadUrl, obj.file, {
          checkpoint: checkpoint,
          progress: (percentage, checkpoint) => this.handleProgess(percentage, checkpoint, obj,),
        }).then(result => {
          const resultClone = result;
          console.log(result, '00000')
          this.bucketName = result.bucket
          let resultArr = resultClone.res.requestUrls[0].split('?')[0];
          console.log(result, '00000')
          const temp = {
            // name: obj.name,
            name:beforeNames.toLocaleLowerCase() + '.' + afterNames.toLocaleLowerCase(),
            size:  obj.size,
            url:   obj.path,
            bucketName: this.bucketName
          }
          console.log('file-obj', result, '====xxx')
          this.$emit('file-obj', temp)
          const resObj = Object.assign({}, temp, {index: obj.index})
          resolve(resObj)
          this.$refs.file.value = null 
          this.$set(this.picList, obj.index, Object.assign(this.picList[obj.index], {url: resultArr, bucketName: this.bucketName}))
          console.log(this.picList, "=====ccccc")
          
        }).catch(err => {
          console.log('Resume multipart upload failed === ', err);
          if (err.name==='cancel') {
            const resObj = Object.assign({isCancel: true}, obj, err)
            resolve(resObj)
          } else {
            reject(err)
          }
        });
      })
    },
    // async initOSSClient(datas) {
		// 		const OSS = require('ali-oss');
		// 		if(this.fileType == 3){
		// 			this.bucketName = datas.data.privateBucket
		// 		}else{
		// 			this.bucketName = datas.data.bucket || datas.data.bucketName
		// 		}
		// 		this.ossClient = new OSS({
		// 			region: datas.data.region,
		// 			accessKeyId: datas.data.accessKeyId,
		// 			accessKeySecret: datas.data.accessKeySecret,
		// 			bucket: this.bucketName, /* 装图片的桶名 */
		// 			stsToken: datas.data.securityToken,
		// 			endpoint: datas.data.endpoint, // 新增加
		// 		});
		// },
    initOSSClient(datas) {
      this.ossClient = new OSS({
        region: datas.data.region,
        accessKeyId: datas.data.accessKeyId,
        accessKeySecret: datas.data.accessKeySecret,
        bucket: datas.data.bucket || datas.data.bucketName /* 装图片的桶名 */,
        stsToken: datas.data.securityToken,
        endpoint: datas.data.endpoint // 新增加
      });
      // return ossClient;
    },
    handleProgess(percentage, checkpoint, obj) {
				const cpt = JSON.stringify(checkpoint)
				if (percentage!==1) {
					localStorage.setItem('ossCheckpoints-' + obj.index, cpt)
				} else {
					localStorage.removeItem('ossCheckpoints-' + obj.index)
				}
        const fileloadingNum = Math.ceil(percentage * 100);
				let beforeName = ''
        let afterName = ''
				console.log('item',obj.name)
				// 拿到出去后缀的名字
				var count =  obj.name.split('.').length
				obj.name.split('.').forEach((ite,ind) => {
          if(ind <= count - 2){
            if(ind == count - 2){
              beforeName += ite
            }else{
              beforeName += ite + '.'
            }
          }
        })
        afterName = obj.name.split('.')[count-1]
        let temp =  {
          index: obj.index,
          percent: fileloadingNum,
        // name: obj.name,
          name:beforeName.toLocaleLowerCase() + '.' + afterName.toLocaleLowerCase(),
          ri: obj.index,
          counts: this.counts,
					beforeName:beforeName.toLocaleLowerCase(),
					afterName:afterName.toLocaleLowerCase()
				}
				console.log('temp',temp)
        if (checkpoint) {
          console.log('checkpoint',checkpoint)
          temp = Object.assign(temp, {
              uploadName: checkpoint.name,
              uploadId: checkpoint.uploadId
          })
        }
        // console.log(this.picList, this.picList[obj.index], 'this.picList[obj.index]')

        // this.picList[obj.index].progress = fileloadingNum
        this.$set(this.picList, obj.index, Object.assign(this.picList[obj.index], {progress: fileloadingNum, fileType: 4}))
        // this.$set(this.picList[obj.index], 'progress', fileloadingNum)
        this.$emit('fileloadingdata', temp)
		},
    async abortUpload(obj) {
      await this.ossClient.abortMultipartUpload(obj.uploadName, obj.uploadId);
    },
    creatFileUrl(name) {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const timestamp = new Date().getTime();
      const fileSuffix = name.lastIndexOf(".");
      const fileExt = name.substring(fileSuffix); // 后缀名
      const storeAs = `${timestamp}${fileExt}`;
      return `${year}/${this.add0(month)}/${storeAs}`;
    },
    add0(m) {
      return m < 10 ? `0${m}` : m;
    },

   
    createUploader() {
      let self = this;
      // eslint-disable-next-line no-undef
      // eslint-disable-next-line no-undef
      const uploader = new AliyunUpload.Vod({
          timeout: 600000,
          partSize: 1048576,  //分片大小默认1 MB，不能小于100 KB
          parallel: 5,  // 并行上传分片个数，默认5
          retryCount: 3, // 网络原因失败时，重新上传次数，默认为3
          retryDuration: 2,  // 网络原因失败时，重新上传间隔时间，默认为2秒
          userId: 1923859927839944,
          onUploadstarted(uploadInfo) {
              if (!uploadInfo.videoId) {
                  self.$api.resource.getUploadVideoParam(`fileName=${uploadInfo.file.name}&fileType=1`).then(({ data }) => {
                      if(data === null) {
                        // 
                        console.log(uploadInfo, 'uploadInfo')
                          self.uploadFailed(uploadInfo);

                      }
                      const { uploadAuth } = data;
                      const { uploadAddress } = data;
                      const { videoId } = data;
                      uploader.setUploadAuthAndAddress(
                          uploadInfo,
                          uploadAuth,
                          uploadAddress,
                          videoId,
                      );
                  });
              } else {
                  self.$api.resource.refreshUploadVideo(`videoId=${uploadInfo.videoId}`).then(({ data }) => {
                    
                      const { uploadAuth } = data;
                      const { uploadAddress } = data;
                      const { videoId} =data;
                      uploader.setUploadAuthAndAddress(
                          uploadInfo,
                          uploadAuth,
                          uploadAddress,
                          videoId,
                      );
                  });
              }
          },
          onUploadSucceed(uploadInfo,) {
              const obj = {
                file: uploadInfo.file
              }
              // console.log(uploadInfo, '===xxxxccc====')
              const videoUrl = `https://${uploadInfo.bucket}.oss-cn-beijing.aliyuncs.com/${uploadInfo.object}`
              obj.url = videoUrl
              // self.$emit('media', obj)
              // callback(videoUrl)
              // self.setVideoUrl(obj)
              // self.videoData.videoId.push(uploadInfo.videoId);
              // self.videoData.videoName.push(uploadInfo.file.name);
              // self.videoData.videoUrl.push(videoUrl)
              self.uploadSucceed(uploadInfo, obj);
          },

          onUploadFailed(uploadInfo) {
              self.uploadFailed(uploadInfo);
          },
          onUploadCanceled(uploadInfo) {
              self.loading = false;
              self.uploadCancel(uploadInfo)
          },
          onUploadProgress(uploadInfo, totalSize, loadedPercent) {
              // self.progress = Math.ceil(loadedPercent * 100);
              // let progress = Math.ceil(loadedPercent * 100);

              self.isT = true;
              self.setUploadProgress(
                  uploadInfo.ri,
                  loadedPercent,
                  totalSize,
              );
          },
          onUploadTokenExpired(uploadInfo) {
              self.progressT = "音视频上传超时，稍后再试";
              setTimeout(function(){
                  self.isT = false;
              },1000)
              self.$api.resource.refreshUploadVideo(`videoId=${uploadInfo.videoId}`).then(({ data: { result } }) => {
                  const uploadAuth = result.upload_auth;
                  uploader.resumeUploadWithAuth(uploadAuth);
              });
          },
          onUploadEnd() {
              setTimeout(function(){
                  self.isT = false;
              

              },1000)
              self.uploadEnd();
          },
      });
      console.log(uploader, '3333')
      return uploader;
    },
    checkFile(list) {
        // const files = Array.from(list).filter(v => v.file.size <= this.maxSize);
        return new Promise((resolve, reject) => {
            if (!list.length) {
                this.$message.error('请检查上传的视频格式和大小');
                reject();
            }
            resolve();
        });
    },
    parseData(listFiles) {
        return listFiles.map(v => ({
            ri: v.ri,
            name: v.file.name,
            // size: this.byteToM(v.file.size),
            size: v.file.size,
            beforeName:this.beforeFomate(v.file.name),
            afterName:this.afterFomate(v.file.name),
            progress: 0,
        }));
    },
    byteToM(byte) {
        return (byte / (1024 * 1024)).toFixed(2);
    },
    beforeFomate(name){
        let beforeName = ''
        var count =  name.split('.').length
        name.split('.').forEach((ite,ind) => {
            if(ind <= count - 2){
                if(ind == count - 2){
                    beforeName += ite
                }else{
                    beforeName += ite + '.'
                }
            }
        })
        return beforeName;
    },
    afterFomate(name){
        let afterName = ''
        var count =  name.split('.').length
        afterName = name.split('.')[count-1]
        return afterName
    },
    setUploadProgress(ri, loadedPercent ) {
        const { videoList } = this;
        let index = 0;
        let percent = loadedPercent;
        let loadedSize = 0;
        // eslint-disable-next-line no-plusplus

        for (let i = 0; i < this.videoList.length; i++) {
            if (videoList[i].ri === ri) {
                index = i;
                // videoList[i].progress = progress
            }
        }
        loadedSize = (videoList[index].size * percent).toFixed(2);
        // percent = Math.floor(percent * 100);
        this.$set(
            videoList,
            index,
            Object.assign(videoList[index], { percent, loadedSize, index: index, progress:  Math.ceil(loadedPercent * 100)}),
        );
    },
    abortUploadImg(obj,index) {
        this.uploader.cancelFile(index)
        this.$emit('on-upload-cancel', obj);
    },
    uploadSucceed(info, urlObj) {
      let index = -1
      for (let i = 0; i < this.videoList.length; i++) {
          if (this.videoList[i].ri === info.ri) {
            index = i;
          }
      }
      if(index != -1) {
        this.$set(
          this.videoList, 
          index, 
          Object.assign(this.videoList[index], {url: urlObj.url,videoId: info.videoId, fileName: info.file.name}),
        )
      }
      return 
    },
    uploadFailed(info) {
        // this.$toast.error('上传失败');
        // this.progressT = "音视频上传失败";
        // setTimeout(function(){
        //     this.isT = false;
        // },1000)
        let index = -1
        // this.uploader.cleanList();
         for (let i = 0; i < this.videoList.length; i++) {
          if (this.videoList[i].ri === info.ri) {
            index = i;
          }
        }
        if(index != -1) {
          this.videoList.splice(index, 1)
        }

        console.debug(info)
    },
    uploadEnd() {
        // this.loading = false;
        // this.progressT = "音视频上传中···";
        // this.$emit("update:showMedia", false);
        this.uploader.cleanList();

    },
    uploadCancel(val) {
        console.debug('取消',val)
        this.loading = false;
        // this.$emit('on-upload-cancel', val);
    },

  }
}
</script>
<style lang="stylus" scope>
.homework-content
  .pop-zuoye
    background-color transparent
  .van-dialog__footer
    width 100%
</style>
<style lang="stylus" scope>
.ellipsis
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
.homework-content
  background-color #fff
  padding-bottom 160px
  font-family: Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei";
  .hw-local-preview
    position absolute 
    right 0px
    top 0px
    width 56px
    height 56px
    // background-image url('../../../assets/images/course/zuoye/del-btn.png')
    background-size 100%
  .content
    width 100%
    background-color #F9F9F9
    
    // box-sizing border-box
    // &.comment 
    //   padding-top 30px
  .video-logo
    position absolute 
    top 50%
    left 50%
    width 52px
    height 52px
    transform translate(-50%, -50%)
    .homework-video-playButton
        font-size:52px;
  .tooltip
    display flex
    flex-direction column
    align-items center
    justify-content center 
    padding 64px 0 48px
    .bg-img 
      width 228px
      height  164px
    .warn
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #202124;
      margin-top 15px
    .tip-text 
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #202124;
      margin-top 32px
    .buttons
      display flex
      justify-content space-between
      margin-top 48px
      padding 0 48px
      .button
        border-radius 44px
        font-size 32px
        width 236px
        height 80px
        border 2px solid rgba(0,0,0,0)
        line-height 80px
      .cancle-submit
        background-color #fff 
        color #3860FF
        border-color #3860FF
        margin-right 22px
      .confirm 
        background-color #3860FF
        color #fff
  .preview-img
    width 100%
  .player-wraper
    width 640px
    height 90vh
  .teacher-comment-wraper
    background-image url('../../../assets/images/course/zuoye/comment-wraper-bg.png')
    background-size 100% 100%
    background-repeat no-repeat
    width 100%
    padding-bottom 30px
    padding-top 30px
  .tearcher-comment-content
    background-image url('../../../assets/images/course/zuoye/comment-bg.png')
    background-size 100% 100%
    background-repeat no-repeat
    margin 0px 30px 0px
    position relative
  .teacher-comment
    width 690px
    box-sizing border-box
    // margin 0px 30px 0px
    display flex 
    background-position 28px 0
    background-repeat no-repeat 
    background-size 154px 111px
    // background-color #fff
    &.pass
      background-image url('../../../assets/images/course/zuoye/pass.png')
    &.inpass
      background-image url('../../../assets/images/course/zuoye/inpass.png')
    .teach
      position absolute
      right 0
      top 0
      width: 128px;
      height: 40px;
      // border: 1px solid rgba(151, 151, 151, 0.13);
      text-align center 
      line-height 40px
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666; 
      background-color #F9F9F9
      border-radius 0 0 0 8px
    .left
      padding 84px 17px 40px 28px
      width 501px
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 42px
      word-wrap:break-word;
      word-break:break-all;
    .right 
      flex 1
      display flex 
      justify-content right 
      flex-direction column
      
      img 
        width 104px
        height 114px
        margin-top 80px
        margin-bottom 56px
  .hw-title
    background-color #fff
    box-sizing border-box
    padding 38px 30px 20px
    margin-bottom 20px
    .title 
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 34px;
    .hm-content
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 42px
      margin-top 30px
      margin-bottom 30px
    .fujian
      background-color #fff
      .item
        display flex 
        justify-content space-between
        align-items center 
        height: 88px;
        background: #F9F9F9;
        border-radius: 8px;
        padding-left 22px 
        margin-bottom 20px
        .logo
          width 42px
          height 44px
        .hw-name
          flex 1
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          padding-left 22px
          display flex
          align-items center
          height 88px
          line-height 88px
          .suffix
            flex 1
          .prefix
            max-width 490px
            &.is-zip
              max-width 220px
        .more
          width 65px
          background-image url('../../../assets/images/course/zuoye/more.png')
          height 42px
          background-size 5px 24px
          background-position center
          background-repeat no-repeat
        .text 
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          padding 0 30px
  .stu-answer
    width 100%
    background-color #fff 
    box-sizing border-box
    padding 38px 0px 40px 0px
    .title 
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 34px;
      padding-bottom 30px
      padding-left 30px
    .upload-list
      display flex 
      flex-wrap wrap
      padding-left 30px

      .upload-item
        width: 154px;
        height: 154px;
        // background: #D8D8D8;
        border-radius: 8px;
        margin-right 22px
        margin-bottom 40px
        position relative
        

        // box-sizing border-box
        background-color #F9F9F9
        .zhuanma
          width 154px
          display flex
          height 154px
          flex-direction column
          align-items center
          justify-content center
          font-weight: 400;
          color: #333333;
          font-size: 22px;
        &.show-border 
          border: 1px dashed #e4e4e4;
        &:nth-child(1)
          margin-left 0
        &.uploader
          display flex 
          flex-direction column 
          justify-content center
          align-items center
          .homework-upload-icon
            font-size:46px;
          span 
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
            margin-top 10px
        img 
          width: 154px;
          height: 154px;
          border-radius: 8px;
          display block
        video 
          width: 152px;
          height: 152px;
          border-radius: 8px;

        .close-btn
          position absolute
          right -14px
          top -14px
          width 48px
          height 48px
          .homework-del-button
            font-size:48px;
        .progress
          position absolute
          left 0
          bottom 0
          width 100%
          height 60px
          background-color #4884FF
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 60px
          text-align center
          opacity: 0.69;
    .message
      padding 28px 30px
      margin 0 30px
      background: #F9F9F9;
      border-radius: 8px;
      border: 1px solid #E4E4E4;
      box-sizing border-box
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 42px;
      // >>>.van-cell
      //   padding 0px
  .sub-btn
    position fixed
    left 50%
    bottom 72px
    transform translateX(-50%)
    width: 690px;
    height: 88px;
    background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
    border-radius: 44px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 88px;
    text-align center
  .pop-wraper
    width 720px
    margin 0 auto
    background: #FFFFFF;
    border-radius: 24px;
    .name-resource
      min-height: 37px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 37px;
      text-align center
      padding 21px 0
    .preview-donload
      font-size: 36px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4884FF;
      line-height: 36px;
      padding 32px 0
      text-align center
      border-top 1px solid #C6C6C6;

  .cancle
    width: 720px;
    height: 108px;
    margin 10px auto 34px
    background: #FFFFFF;
    border-radius: 24px;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4884FF;
    line-height: 108px
    text-align center

        




</style>